import { Inject, Injectable } from "@angular/core";
import {
  getDownloadURL,
  ref,
  Storage,
  uploadString,
} from "@angular/fire/storage";
import { deleteObject } from "firebase/storage";
import { finalize, firstValueFrom, from } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  imageUrl!: string;

  constructor(@Inject(Storage) private storage: Storage) {}

  async uploadImage(filePath: string, croppedImage: string): Promise<string> {
    const fileRef = ref(this.storage, filePath); // 🔥 Create reference using ref()

    try {
      // 🔥 Upload the image using uploadString()
      const task = from(uploadString(fileRef, croppedImage, "data_url"));

      // 🔥 Wait for upload to complete
      await firstValueFrom(task);

      // 🔥 Get the download URL
      const url = await firstValueFrom(from(getDownloadURL(fileRef)));

      console.log("URL da imagem:", url);
      return url;
    } catch (error) {
      console.error("Erro ao obter a URL da imagem:", error);
      throw error;
    }
  }

  async deleteImage(filePath: string): Promise<void> {
    try {
      const fileRef = ref(this.storage, filePath);
      await deleteObject(fileRef);
      console.log(`Imagem deletada: ${filePath}`);
    } catch (error) {
      console.error("Erro ao deletar a imagem:", error);
      throw error;
    }
  }
}
